var _path, _path2, _path3, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMinitour(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 45C5 67.0914 22.9086 85 45 85C67.0914 85 85 67.0914 85 45C85 22.9086 67.0914 5 45 5C22.9086 5 5 22.9086 5 45ZM83 45C83 65.9868 65.9868 83 45 83C24.0132 83 7 65.9868 7 45C7 24.0132 24.0132 7 45 7C65.9868 7 83 24.0132 83 45Z",
    fill: "#FCA66C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1687 27.4547C24.5595 26.5277 24.6852 25.3003 25.4695 24.516C26.2539 23.7316 27.4812 23.606 28.4082 24.2151L48.6576 37.5219C49.7982 38.2714 50.7733 39.2465 51.5228 40.3871L64.8296 60.6365C65.4387 61.5635 65.3131 62.7909 64.5287 63.5752C63.7444 64.3595 62.517 64.4852 61.5901 63.876L41.3407 50.5693C40.2001 49.8197 39.225 48.8446 38.4754 47.704L25.1687 27.4547Z",
    fill: "#FCA66C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6015 30.9073L48.6576 37.5155C49.7982 38.2651 50.7733 39.2402 51.5229 40.3808L64.8296 60.6302C65.4388 61.5571 65.3131 62.7845 64.5288 63.5688V63.5688C63.7444 64.3532 62.5171 64.4788 61.5901 63.8697L51.3968 57.1712",
    stroke: "#383434",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45.9528,
    cy: 45.9527,
    r: 2.85714,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 40,
    transform: "matrix(-1 0 0 1 85 5)",
    stroke: "#383434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinitour);
export default __webpack_public_path__ + "static/media/minitour.e897126e5fd83de9904bc5ad7761833c.svg";
export { ForwardRef as ReactComponent };